import Link from 'next/link';

import { BANNER_SETTINGS } from '@/constants/banner';
import { NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID } from '@/constants/chain';

import { useAnnouncementBanner } from '@/hooks/useAnnouncementBanner';

import { fontStyles } from '@/styles/typography';

import { AnnouncementBanner } from '@/ui/AnnouncementBanner';
import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

import { routes } from '@/utils/routes';
import { getDefaultPairForChain } from '@/utils/swap';

export const ApplicationBanner = () => {
  const { showBanner, hideBanner, customContent } = useAnnouncementBanner();
  const { error, newChain } = BANNER_SETTINGS;

  if (!showBanner) {
    return null;
  }

  if (customContent) {
    const { description, ...bannerProps } = customContent;
    return <AnnouncementBanner {...bannerProps}>{description}</AnnouncementBanner>;
  }

  if (error) {
    return (
      <AnnouncementBanner title={error.title} variant="error" onDismiss={hideBanner}>
        {error.description}
      </AnnouncementBanner>
    );
  }

  if (newChain) {
    return (
      <AnnouncementBanner variant="new" onDismiss={hideBanner}>
        <div className="flex flex-row items-center gap-1.5">
          <ChainAvatar chainId={newChain.id} size={20} />
          <p className={fontStyles({ variant: 'LABEL_MD' })}>{newChain.name}</p>
          <p>is live on Matcha.</p>
          <Link
            href={{
              pathname: routes.TOKEN_PROFILE,
              query: {
                chainId: NETWORK_NAME_FOR_URLPATH_PER_CHAIN_ID[newChain.id],
                contractAddresses: [getDefaultPairForChain(newChain.id).buyAddress],
              },
            }}
            className={fontStyles({
              variant: 'LABEL_MD',
              class:
                'whitespace-nowrap text-token-green-1100 underline hover:text-token-green-1200',
            })}
          >
            Try it now
          </Link>
        </div>
      </AnnouncementBanner>
    );
  }

  return null;
};
